// Only what the module renders or edits. createdByUser (name, email) and the nested customer
// used to be selected and were never shown.
export const listOrders = `
   query listOrders($filter: OrdersFilterInput, $limit: Int, $nextToken: String, $sort: SortInput) {
       listOrders(filter: $filter, limit: $limit, nextToken: $nextToken, sort: $sort) {
           items {
              id
              customerId
              subscriptionId
              status
              created
              updated
           }
           nextToken
       }
   }
`;

export const getOrder = `
   query getOrder($id:ID!) {
       getOrder(id:$id) {
         id
         customerId
         subscriptionId
         status
         created
         updated
       } 
}`;
